import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit, inject, signal } from '@angular/core';

import { routeNames } from '../../../../shared/route-names';
import { Oauth2Service } from '../../services/oauth2.service';
import { UserService } from '../../../user/services/user.service';
import { Oauth2Provider } from '../../../../models/provider.model';
import { NotificationService } from '../../../shared/services/notification.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  private _userService = inject(UserService);
  private _oauth2Service = inject(Oauth2Service);
  private _notificationService = inject(NotificationService);
  private _router = inject(Router);
  private _activatedRoute = inject(ActivatedRoute);
  providers = signal<Oauth2Provider[]>([]);

  constructor() {
    if (this._userService.isLoggedIn()) {
      this._router.navigate([`${routeNames.root + routeNames.home}`]);
    }
    this.getProviders();
  }

  ngOnInit(): void {
    const error = this._activatedRoute.snapshot.queryParams['error'];
    if (error) {
      this._notificationService.error(error);
    }
  }

  public getProviders() {
    this._oauth2Service.getProviders().subscribe((providers: Oauth2Provider[]) => {
      this.providers.set(providers);
    });
  }

  public loginWithOAuth2(url: string) {
    this.redirect(url);
  }

  public redirect(url: string) {
    window.location.href = url;
  }
}
